import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationOrderedItemsReport = fp.get(
  'reservation.reports.orderedItems'
);

export const getAll = createSelector(
  getReservationOrderedItemsReport,
  fp.get('all')
);

export const getIsFetching = createSelector(
  getReservationOrderedItemsReport,
  fp.get('fetching')
);
export const getIsFetched = createSelector(
  getReservationOrderedItemsReport,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getReservationOrderedItemsReport,
  fp.get('fetchingError')
);
